<ng-container *transloco="let t">
    <div fxLayoutAlign="center center">
        <span class="collection-header">{{
            t("program.collection.header") | uppercase
        }}</span>
    </div>
    <div fxLayoutAlign="center center">
        <span class="collection-subheader">{{
            t("program.collection.subheader")
        }}</span>
    </div>

    <div
        class="program-card-collection"
        fxLayout="row wrap"
        fxLayoutGap="0px grid"
        fxLayoutAlign="center center"
    >
        @for (program of programs; track program) {
        <app-program-card
            [program]="program"
            (updateSelectedPrograms)="updateSelectedPrograms(program)"
        >
        </app-program-card>
        }
    </div>
    @if (client?.waitlistProviderIds?.length) {
    <div fxLayout="column" fxLayoutAlign="center center" class="apply">
        <div>
            {{ t("waitlist.apply.need-help") }}
            <a
                href="javascript:void(0)"
                (click)="startApplication()"
                class="apply-link"
                >{{ t("waitlist.apply.click-to-start") }}
            </a>
        </div>
        <div>{{ t("waitlist.apply.will-be-contacted") }}</div>
    </div>
    }
    <div
        fxLayoutAlign="center center"
        class="search-provider-wrapper"
        [style.visibility]="
            this.selectedProgramIds.length === 0 ? 'hidden' : 'visible'
        "
    >
        <button
            mat-raised-button
            color="accent"
            (click)="searchProviders()"
            name="Search Providers"
            id="search-providers-button"
        >
            {{ t("program.action") | uppercase }}
        </button>
    </div>
</ng-container>
